/**
 * Source-backed reconciliation snapshot prepared from the supplied 2026 workbooks.
 *
 * This is intentionally kept separate from operational records: the source files
 * contain inconsistent labels, formulas and duplicate client names, so these
 * figures are evidence for review until an idempotent row-level import is approved.
 */
export const ledgersyncSourceSummary = {
  asOf: '2026-07-10',
  sourceFiles: 7,
  clientRecords: 34,
  collectionRows: 463,
  collectionsTotal: 7866079.4,
  collectionsByCategory: {
    retainer: 1962600,
    otherOtf: 2200555.6,
    birRemittance: 2612859.3,
    serviceFees: 906934.5,
    statutory: 36330,
    arOther: 146800,
  },
  outstandingReceivables: 42002.48,
  outstandingCashAdvances: 109775,
  pettyCashSheets: 25,
  slspRows: 394,
  slspMissingTinRows: 22,
  dataQualityFlags: [
    'All 34 client tracker rows use placeholder TINs and need verified taxpayer identifiers before posting.',
    '22 SLSP rows have no supplier TIN and must be resolved before BIR submission.',
    'Petty-cash sheets change category columns and contain formula/date inconsistencies.',
  ],
} as const

export type LedgerSyncSourceSummary = typeof ledgersyncSourceSummary
